import { useFormContext } from 'react-hook-form';
import { Radio, Date, Input, Country } from '@/components/fields';

export default function Disqualification(): JSX.Element {
  const { errors, watch } = useFormContext();
  const isDisqualified = watch('disqualified') === 'disqualified_yes';

  return (
    <>
      <div className="md:flex md:items-center">
        <div className="md:w-2/5 md:pr-4">
          <span className="block text-sm leading-5 font-normal text-gray-900">
            Are you currently disqualified from driving in the UK (including
            Northern Ireland, Jersey, Guernsey and Isle of Man) or any other
            country? <sup className="text-red-600 font-sans">*</sup>
          </span>
        </div>
        <div className="md:w-2/5 md:pl-4">
          <div className="flex items-center">
            <Radio name="disqualified" id="disqualified_yes" className="mr-4">
              Yes
            </Radio>
            <Radio name="disqualified" id="disqualified_no" className="mr-4">
              No
            </Radio>
          </div>
          {errors['disqualified'] ? (
            <p className="mb-4 text-sm text-red-600">
              {errors['disqualified'].message}
            </p>
          ) : null}
        </div>
      </div>
      {isDisqualified ? (
        <>
          <Date id="disqualification_date" isRequired skipYears={0}>
            Disqualification date
          </Date>
          <Input id="disqualification_court" isRequired>
            Court Name
          </Input>
          <Country id="disqualification_country" isRequired>
            In which European Union or European Economic Area country have you
            lived in the last 12 months?
          </Country>
        </>
      ) : null}
    </>
  );
}
